module.exports = __webpack_public_path__ + "img/ricelog_pinicon_010.54c29db5.png";